import { useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../lib/queryKeys'

export default function useInvalidateSubscriptionsQuery() {
  const queryClient = useQueryClient()

  return (companyId: number, companyUserId: number) => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.subscriptions(companyId, companyUserId),
    })
  }
}
